var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: _vm.title,
        id: "source-compare",
        description: _vm.description,
        component: _vm.component,
        icon: "mdi mdi-compare-horizontal",
        optional: _vm.optional,
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-grow flex flex-col pb-4" },
        [
          _c(
            "toolbar",
            [
              _c(
                "field",
                { staticClass: "w-64", attrs: { disabled: "" } },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: [
                        {
                          name: "Current Source File",
                          rawDataDocId:
                            _vm.fileSource !== null
                              ? _vm.fileSource.rawDataDocId
                              : "",
                        },
                      ],
                      "text-field": "name",
                      "value-field": "rawDataDocId",
                      "auto-assign": "",
                    },
                    model: {
                      value: _vm.currentSource,
                      callback: function ($$v) {
                        _vm.currentSource = $$v
                      },
                      expression: "currentSource",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "field",
                { staticClass: "w-48 ml-2" },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.currentSourceKeys,
                      "text-field": "headerName",
                      "value-field": "headerName",
                      placeholder: "Select Compare Key",
                      searchable: _vm.currentSourceKeys.length > 10,
                    },
                    model: {
                      value: _vm.currentKey,
                      callback: function ($$v) {
                        _vm.currentKey = $$v
                      },
                      expression: "currentKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grow" }),
              _vm._v(" "),
              _c(
                "field",
                { staticClass: "w-112 mr-2" },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.previousFileSource,
                      placeholder: "Select Previous Source",
                      "value-field": "value",
                    },
                    model: {
                      value: _vm.previousSource,
                      callback: function ($$v) {
                        _vm.previousSource = $$v
                      },
                      expression: "previousSource",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "field",
                {
                  staticClass: "w-48 mr-2",
                  attrs: {
                    disabled:
                      _vm.previousSource.length === 0 ||
                      _vm.previousSourceKeys.length === 1,
                  },
                },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.previousSourceKeys,
                      placeholder: "Select Compare Key",
                      "value-field": "value",
                    },
                    model: {
                      value: _vm.previousKey,
                      callback: function ($$v) {
                        _vm.previousKey = $$v
                      },
                      expression: "previousKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("step-pager", {
                staticClass: "my-1",
                attrs: { disabled: !_vm.isValid },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isValid
            ? _c("compare", {
                key: _vm.compareKey,
                staticClass: "flex-grow my-4",
                attrs: {
                  leftDisplayName: `Current (${_vm.fileSource.name})`,
                  rightDisplayName: `Former (${_vm.previousSourceName})`,
                  leftKey: `[${_vm.currentKey}]`,
                  rightKey: `[${_vm.previousKey}]`,
                  leftExtRefAlias: "RawDataImport",
                  rightExtRefAlias: "RawDataImport",
                  leftExtRefRelativeURL: _vm.currentSource,
                  rightExtRefRelativeURL: _vm.previousSource,
                  comparisionFlow: _vm.comparisionFlow,
                  scratchApiRoot: _vm.parsedScratchPadUrl,
                  authToken: _vm.jwt,
                  compareUploadedFiles: true,
                  isNew: true,
                  onExport: _vm.onExport,
                  lsProps: _vm.lsProps,
                },
              })
            : _c("div", {
                staticClass:
                  "flex-grow border border-gray-500 bg-white rounded my-4",
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }